import React from 'react'
import Header from "../components/Header/Header";

const ErrorPage = () => {
  return (
      <>
          <h3>404 Not Found!!</h3>
      </>
  )
}

export default ErrorPage
